module.exports = __webpack_public_path__ + "img/zz.4f36a23c.jpg";